// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"35":"b02e551d","444":"b0c4ec13","466":"29d71d99","612":"868bd871","642":"a9855704","684":"a9855704","776":"b64ceb05","945":"a1fa4b7d","961":"30b0801f","971":"a9855704"}[chunkId] + ".chunk.css";
};